<template>
    <div class="content-page">
        <div class="tab-header">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>账号设置</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="tab-content">
            <el-form
                :model="accountForm"
                :rules="rules"
                ref="accountForm"
                class="account-form"
                label-width="88px"
                :hide-required-asterisk="true"
                status-icon
            >
                <!-- <el-form-item label="账号" prop="account">
                    <el-input type="text" placeholder="请输入账号" v-model="accountForm.account" autocomplete="new-password"></el-input>
                </el-form-item>-->
                <el-form-item label="原密码" prop="oldPassWord">
                    <el-input type="text" placeholder="请输入原密码" v-model="accountForm.oldPassWord"></el-input>
                </el-form-item>
                <el-form-item label="新密码" prop="passWord">
                    <el-input type="text" placeholder="请输入新密码" v-model="accountForm.passWord"></el-input>
                </el-form-item>
                <el-form-item label="确认新密码" prop="rePassWord">
                    <el-input type="text" placeholder="请输入新密码" v-model="accountForm.rePassWord"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="submitForm('accountForm')">修改密码</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
import { modifyPass } from "@/api";
export default {
    data() {
        var validatePass = (rule, value, callback) => {
            if (value === "") {
                callback(new Error("请输入密码"));
            } else {
                if (this.accountForm.rePassWord !== "") {
                    this.$refs.accountForm.validateField("checkPass");
                }
                callback();
            }
        };
        var validatePass2 = (rule, value, callback) => {
            if (value === "") {
                callback(new Error("请再次输入密码"));
            } else if (value !== this.accountForm.passWord) {
                callback(new Error("两次输入密码不一致!"));
            } else {
                callback();
            }
        };
        return {
            accountForm: {
                oldPassWord: "",
                passWord: "",
                rePassWord: ""
            },
            rules: {
                oldPassWord: [{ validator: validatePass, trigger: "blur" }],
                passWord: [{ validator: validatePass, trigger: "blur" }],
                rePassWord: [{ validator: validatePass2, trigger: "blur" }]
            }
        };
    },
    mounted() {},
    methods: {
        submitForm(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    modifyPass(this.accountForm).then(res => {
                        if (res.code == 1) {
                            this.$notify({
                                title: "提示",
                                message: "修改成功",
                                type: "success",
                                duration: 2000
                            });
                            this.$router.push({
                                path: "/login"
                            });
                        } else {
                            this.$notify({
                                title: "提示",
                                message: res.msg,
                                type: "error",
                                duration: 2000
                            });
                        }
                        this.resetForm();
                    });
                } else {
                    this.$notify({
                        title: "提示",
                        message: "请完善提交内容",
                        type: "error",
                        duration: 2000
                    });
                    return false;
                }
            });
        },
        resetForm() {
            this.accountForm = {
                account: "",
                oldPassWord: "",
                passWord: "",
                rePassWord: ""
            };
            this.$refs.accountForm.resetFields();
        }
    }
};
</script>

<style lang="less" scoped>
.content-page {
    .tab-header {
        padding: 12px 20px;
    }
    .tab-content {
        padding: 40px 20px;
        .account-form {
            width: 468px;
        }
    }
}
</style>
